import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col lg:flex-row">
            {/* Desktop Sidebar */}
            <div className="hidden lg:block lg:w-28 fixed lg:relative top-0 left-0 h-full z-20">
                <Sidebar />
            </div>

            {/* Mobile Sidebar (controlled by state) */}
            <Sidebar isOpen={sidebarOpen} toggle={toggleSidebar} />

            {/* Content */}
            <div className="flex-1 flex flex-col lg:ml-0">
                <Header toggleSidebar={toggleSidebar} />
                <main className="flex-1 overflow-y-auto bg-white">
                    <div className="p-8">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Layout; 